declare global {
  interface Window {
    MonacoEnvironment?: any;
  }
}

window.MonacoEnvironment = {
  getWorker(_: string, label: string) {
    switch (label) {
      case 'json':
        return new Worker(
          new URL('./json.worker', import.meta.url),
          { type: 'module' }
        );

      default:
        return new Worker(
          new URL('./editor.worker', import.meta.url),
          { type: 'module' }
        );
    }
  }
};

export {};